import svgTituloMiPerfil from "../../assets/miPerfil/mi_perfil.svg";
import iconoCamara from "../../assets/miPerfil/cambiar foto de perfil.svg";
import NotificationModal from "../../components/NotificationModal/NotificationModal";

import { useState, useEffect, useRef } from "react";
import "./MiPerfil.css";

const MiPerfil = ({ user, setUser }) => {
    const API_BASE = "http://localhost/backend_onelearning/api";
    const fileInputRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [avatarUrl, setAvatarUrl] = useState("");
    const [archivoFoto, setArchivoFoto] = useState(null);
    // Agrega este estado junto a los demás
    const [authProvider, setAuthProvider] = useState("local");
    
    const [isUpdateOpen, setUpdateOpen] = useState(false);
    
    const [formData, setFormData] = useState({
        nombre: "", apellido: "", correo: "", celular: "", passwordNueva: ""
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (user) {
            setFormData({
                nombre: user.first_name || "",
                apellido: user.last_name || "",
                correo: user.email || "",
                celular: user.phone || "",
                passwordNueva: ""
            });
            setAvatarUrl(user.photo_url);
            setAuthProvider(user.auth_provider);
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (errors[name]) setErrors({ ...errors, [name]: "" });
    };

    // --- MANEJO DE LA FOTO ---
    const handleClicCamara = () => fileInputRef.current.click();

    const handleCambioFoto = (e) => {
        const file = e.target.files[0];
        if (file) {
            setArchivoFoto(file);
            setAvatarUrl(URL.createObjectURL(file));
        }
    };

    const validate = () => { /* tu validación aquí */ return {}; };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Como enviamos un archivo físico, DEBEMOS usar FormData, no JSON
        const dataToSend = new FormData();
        dataToSend.append('celular', formData.celular);

        // Solo enviamos la contraseña si escribió algo y es cuenta local
        if (formData.passwordNueva && authProvider === 'local') {
            dataToSend.append('passwordNueva', formData.passwordNueva);
        }

        // Si el usuario seleccionó una foto nueva, la adjuntamos
        if (archivoFoto) {
            dataToSend.append('foto', archivoFoto);
        }

        try {
            const response = await fetch(`${API_BASE}/user/update_profile.php`, {
                method: 'POST',
                body: dataToSend, // Fetch pone el Content-Type correcto automáticamente para FormData
                credentials: 'include'
            });

            const result = await response.json();

            if (result.status === 'success') {
                setUpdateOpen(true); // Abrimos la notificación de éxito

                setArchivoFoto(null); // Limpiamos el archivo pendiente
                setFormData(prev => ({ ...prev, passwordNueva: "" })); // Limpiamos el campo contraseña
                const freshResponse = await fetch(`${API_BASE}/auth/me.php`, {
                    method: 'GET', credentials: 'include'
                });
                const freshData = await freshResponse.json();

                if (freshData.status === 'success') {
                    // Esto actualiza App.js. Automáticamente el Header,
                    // Mis Cursos y Mi Perfil cambiarán la foto y nombre ¡al instante!
                    setUser(freshData.user);
                }

            } else {
                alert("Error: " + result.message);
            }
        } catch (error) {
            console.error("Error al actualizar:", error);
            alert("Ocurrió un error al actualizar");
        }
    };

    // if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>Cargando perfil...</div>;

    return (
        <>
            <section className="miPerfil-section section-green">
                <div className="container">

                    {/* === CONTENEDOR DEL BANNER (El que empuja a la derecha) === */}
                    <div className="banner-svg-container">

                        {/* 🔥 NUEVO ENVOLTORIO (El que mantiene junta a la imagen y la foto) 🔥 */}
                        <div className="svg-wrapper">

                            {/* 1. EL SVG DE FONDO */}
                            <img src={svgTituloMiPerfil} alt="Mi Perfil" className="img-svg-titulo" />

                            {/* 2. LA ZONA DE LA FOTO Y CÁMARA */}
                            <div className="zona-interactiva-avatar">

                                {/* A. Si hay foto, la mostramos redonda */}
                                {avatarUrl && (
                                    <div className="foto-redonda-usuario">
                                        <img src={avatarUrl} alt="Mi Avatar" />
                                    </div>
                                )}

                                {/* B. La camarita (recuerda usar left si va a la izquierda) */}
                                <button type="button" onClick={handleClicCamara} className="btn-camarita-flotante">
                                    <img src={iconoCamara} alt="Cambiar foto" />
                                </button>

                                {/* C. Input oculto */}
                                <input
                                    type="file"
                                    accept="image/png, image/jpeg, image/jpg"
                                    ref={fileInputRef}
                                    onChange={handleCambioFoto}
                                    style={{ display: 'none' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* === FORMULARIO === */}
            <div className="container-contact container-contact-2 mi-perfil section-white" style={{ background: 'white', marginTop: '30px' }}>
                <form className="formulario formulario-2" onSubmit={handleSubmit}>

                    <div className="fila">
                        <div className="campo">
                            <label>Nombre</label>
                            <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} disabled />
                        </div>
                        <div className="campo">
                            <label>Apellido</label>
                            <input type="text" name="apellido" value={formData.apellido} onChange={handleChange} disabled />
                        </div>
                    </div>

                    <div className="fila">
                        <div className="campo">
                            <label>Correo</label>
                            <input type="email" name="correo" value={formData.correo} onChange={handleChange} disabled />
                        </div>
                        <div className="campo">
                            <label>Celular</label>
                            <input type="tel" name="celular" value={formData.celular} onChange={handleChange} />
                        </div>
                    </div>

                    {/* === CAMBIAR CONTRASEÑA (SOLO CUENTAS LOCALES) === */}
                    {authProvider === 'local' && (
                        <div className="fila">
                            <div className="campo">
                                <label>Nueva contraseña (Opcional)</label>
                                <input
                                    type="password"
                                    name="passwordNueva"
                                    placeholder="Déjalo en blanco para mantener la actual"
                                    value={formData.passwordNueva}
                                    onChange={handleChange}
                                    className={errors.passwordNueva ? "input-error" : ""}
                                />
                                {errors.passwordNueva && <span className="error-text">{errors.passwordNueva}</span>}
                            </div>
                        </div>
                    )}

                    <button type="submit" className="btn-submit">
                        Guardar cambios
                    </button>
                </form>
            </div>
            
            <NotificationModal 
                isOpen={isUpdateOpen} 
                title="ACTUALIZACIÓN DE DATOS EXITOSA" 
                buttonText="Cerrar" 
                onClose={() => setUpdateOpen(false)} 
            />
        </>
    );
};

export default MiPerfil;